import React, { ReactElement} from 'react';
import cn from 'classnames';
import Image from '@base/lib/ThemeImage'
import styles from './index.module.less';

type IProps = {
    className?: string;
    iconUrl: string;
    iconWidth?: number;
    num: number | string | ReactElement;
}

const RewardCoinsItem: React.FC<IProps> = (props) => {
    const {
        className,
        iconUrl,
        iconWidth = 23,
        num
    } = props
    return(
        <div className={cn(className, styles['reward_item'], 'flex')}>
            <div className={cn(styles['reward_icon'], 'g-icon')}>
                <Image
                    src={iconUrl}
                    width={iconWidth}
                    height={iconWidth}
                    fixed
                    background={false}
                />
            </div>

            <span className={cn(styles['reward_num'], 'g-num')}>
                {num}
            </span>
        </div>
    );
};

export default RewardCoinsItem